import React from 'react';
import BaseInput from '../Base/BaseInput';
import BaseSelect from '../Base/BaseSelect';
import { CostCenter } from '../../models/CostCenterModel';
import {
  finalizeFormTextField,
  sanitizeFormTextField,
} from '../../utils/textInputSanitize';

type Props = {
  value: CostCenter;
  onChange: (c: CostCenter) => void;
  error?: string | null;
  companies: { value: string; label: string }[];
  fieldErrors?: Record<string, string>;
};

const CostCenterForm: React.FC<Props> = ({ value, onChange, companies, fieldErrors = {} }) => {
  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value: v } = e.target;
    onChange({ ...value, [name]: name === 'company' ? Number(v) : v });
  };

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value: v } = e.target;
    onChange({ ...value, [name]: sanitizeFormTextField(name, v) });
  };

  const handleTextBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value: v } = e.target;
    const next = finalizeFormTextField(name, v);
    if (next !== (value as any)[name]) {
      onChange({ ...value, [name]: next });
    }
  };

  return (
    <div className="costcenter-form">
      <div className="form-row">
        <div className="form-field full-width">
          <BaseSelect
            label="Empresa"
            name="company"
            value={String(value.company ?? '')}
            onChange={handleSelectChange}
            options={companies}
            placeholder="Seleccionar empresa"
          />
          {fieldErrors.company && (
            <div className="form-error" role="alert">
              {fieldErrors.company}
            </div>
          )}
        </div>
      </div>

      <div className="form-row">
        <div className="form-field full-width">
          <BaseInput
            label="Código"
            name="code"
            value={value.code ?? ''}
            onChange={handleTextChange}
            onBlur={handleTextBlur}
            required
            maxLength={50}
            error={fieldErrors.code}
          />
        </div>
      </div>
    </div>
  );
};

export default CostCenterForm;
